import { createSlice } from '@reduxjs/toolkit'

export const workflow = createSlice({
    name: 'workflow',
    initialState: {
        workflowInstanceId: '',
        showProgress: false,
    },
    reducers: {
        setShowProgress: (state, action) => {
            state.showProgress = action.payload;
        },
        setWorkInstanceId: (state,action) => {
            state.workflowInstanceId = action.payload;
        }
    },
});

export const { setShowProgress, setWorkInstanceId } = workflow.actions;

